import {supportsStartupPlayback} from './runtime.js';
// Startup is evaluated once, after account settings and history have loaded.
export const playbackKey=user=>`tm:last-station:${user?.id?`user:${user.id}`:'guest'}`;
export function rememberStation(user,station,storage){
  if(!station?.stationuuid)return;
  try{(storage??globalThis.localStorage)?.setItem(playbackKey(user),JSON.stringify(station));}catch{}
}
export function restoredStation({library,lastStation}){
  const playable=station=>station?.stationuuid&&/^https?:\/\//i.test(station.url_resolved||station.url||'');
  const station=playable(lastStation)?lastStation:library?.recent?.[0];
  return playable(station)?station:null;
}
export function startupStation({settings,library,lastStation,playSignal=0,canResume=supportsStartupPlayback()}){
  if(!canResume||settings?.resumePlaybackOnStartup!==true||playSignal>0)return null;
  return restoredStation({library,lastStation});
}
